import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAppSelector } from 'src/store';
import { selectClassUserByClassId } from 'src/store/model/class_user';
import { isUnavailableCoursePath } from 'src/utils/helper';
import { PATH } from 'src/constants/app';
import { selectFirstContent } from 'src/store/model/class_topic';

const useClassUser = () => {
  const { class_id } = useParams<{ class_id: string }>();
  const navigate = useNavigate();

  const userClass = useAppSelector((state) =>
    selectClassUserByClassId(state, class_id!),
  );
  const first = useAppSelector((state) => selectFirstContent(state, class_id!));
  const user = useAppSelector((state) => state.ui.app.me);
  const isStudent = user?.roles.every((user) => user.name === 'Student');

  useEffect(() => {
    if (class_id && !userClass) {
      return;
    } else if (isStudent && !userClass?.is_paid) {
      navigate(`${PATH.HOME}`, { replace: true });
    }
  }, [userClass]);

  const savedProgress = userClass?.class_progress?.current_progress;
  const currentProgress = isUnavailableCoursePath(
    userClass?.class?.type,
    `/${PATH.CLASS}/${class_id}/${savedProgress}`,
  )
    ? first
    : savedProgress || first;

  // A teacher has no enrolment row; the course still has to render, and
  // "the user" of the enrolment is then simply whoever is signed in.
  return {
    ...userClass,
    user: userClass?.user || user,
    class_progress: {
      ...userClass?.class_progress,
      current_progress: currentProgress,
    },
  } as Model.ClassUser;
};

export default useClassUser;
